import { useButton } from 'reakit';
import { createComponent, createHook } from 'reakit-system';
import { useFocusable } from '../../hooks/useFocusable';
import { useStepperFieldBox } from '../hooks/useStepperBox';
import type {
  StepperFieldButtonHTMLProps,
  StepperFieldButtonOptions,
} from '../types';

export const useStepperFieldButton = createHook<
  StepperFieldButtonOptions,
  StepperFieldButtonHTMLProps
>({
  compose: [useStepperFieldBox, useButton, useFocusable],
  useOptions(options) {
    return {
      padding: 'stepperButtonPadding',
      ...options,
      borderRadius: 'stepperButtonBorderRaduis',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      flexGrow: 0,
      focusable: true,
    };
  },
});

export const StepperFieldButton = createComponent({
  as: 'button',
  useHook: useStepperFieldButton,
});
